module.exports = __webpack_public_path__ + "img/logo_validnews.8b62b3ce.png";